import parse from 'html-react-parser';
import { useEffect, useState } from 'react';

import type { UseCase } from 'src/api/models';

export function sleep(ms: number): Promise<void> {
  return new Promise((r) => setTimeout(r, ms));
}

export function assertDefined<T>(val: undefined | T): asserts val is T {
  if (val === undefined) {
    throw new Error('unexpected undefined');
  }
}

export function fileExtension(filename: string): string {
  return filename
    .slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2)
    .toLowerCase()
    .trim();
}

export async function parseHtmlStringToReact(str: string) {
  return parse(str);
}

export function useParsedHtmlString(str: string | undefined) {
  const [rendered, setRendered] = useState<React.ReactNode>(null);
  useEffect(() => {
    if (!str) {
      setRendered(null);
      return;
    }
    const element = parse(str);
    setRendered(element);
  }, [str]);
  return rendered;
}

export function isUseCaseAbandonedCart(useCase: UseCase): boolean {
  return useCase.name.includes('abandoned');
}

export function removeNulls<T>(obj: T | null | undefined): obj is T {
  return obj !== null || obj !== undefined;
}
